import { Model } from '@vuex-orm/core'

export default class FilesScanType extends Model {
	// This is the name used as module name of the Vuex Store.
	static entity = 'FilesScanTypes'

	// List of all fields (schema) of the post model. `this.attr` is used
	// for the generic field type. The argument is the default value.
	static fields() {
		return {
			id: this.attr(null),
			scan_opd_card_type: this.attr(null),
			scan_opd_card_type_name: this.attr(null),
			scan_opd_card_type_status: this.attr(null),
			scan_opd_card_type_orderby: this.number(0),
			datas: this.attr(null)
		}
	}
}
